import { Button, Icon, Tooltip } from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";
import { useGetOrderMediaConfig } from "../../views/PlaceOrderTest/queryHooks";
import { isPartConfirmationEligibleSupplier } from "./utils/partConfirmationEligibility";

export const RequestPartConfirmationButton = ({
  onClick,
  isAmber = false,
  supplierId,
  size = "md",
}: {
  onClick: (e: React.MouseEvent) => void;
  isAmber?: boolean;
  supplierId?: string;
  size?: "sm" | "md";
  /** Accepted for call-site compatibility; the button is always icon-only. */
  isEstimateOrder?: boolean;
}) => {
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const isEligible = isPartConfirmationEligibleSupplier(
    supplierId,
    mobileConfigs?.part_confirmation_eligible_supplier_ids,
  );

  if (!isEligible) {
    return null;
  }

  return (
    <Tooltip label="Request part confirmation" hasArrow>
      <Button
        size={size}
        height="auto"
        width="auto"
        minW="auto"
        px={2}
        py={1.5}
        borderRadius="md"
        bg={isAmber ? "#fff7ed" : "#eff6ff"}
        color={isAmber ? "#c2410c" : "#4b85f2"}
        border={isAmber ? "1px solid" : "none"}
        borderColor={isAmber ? "#c2410c" : "none"}
        _hover={{ bg: isAmber ? "#ffedd5" : "#d2e4fb" }}
        onClick={(e) => {
          e.stopPropagation();
          onClick(e);
        }}
        aria-label="Request part confirmation"
      >
        <Icon as={FiSend} boxSize={4} />
      </Button>
    </Tooltip>
  );
};
